import React from 'react';
import { Link } from 'react-router-dom';

const BracketButton = ({ children, to, href, onClick, variant = 'dark', className = '' }) => {
  const cls = `bracket-btn ${variant === 'light' ? 'bracket-btn--light' : 'bracket-btn--dark'} ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls} onClick={onClick}>
        <span>{children}</span>
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={cls} onClick={onClick}>
        <span>{children}</span>
      </a>
    );
  }
  return (
    <button type="button" className={cls} onClick={onClick}>
      <span>{children}</span>
    </button>
  );
};

export default BracketButton;
